<template>

  <div class="user">

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="手机"><el-input v-model="formInline.mobile" placeholder="请输入手机号"></el-input></el-form-item>
<!--        <el-form-item label="学校"><el-input v-model="formInline.school_name" placeholder="请输入学校名称"></el-input></el-form-item>-->
        <el-form-item label="身份证"><el-input v-model="formInline.id_card" placeholder="请输入身份证"></el-input></el-form-item>
        <el-form-item label="学生姓名"><el-input v-model="formInline.student_name" placeholder="请输入学生姓名"></el-input></el-form-item>
        <el-form-item label="省市区">
          <el-select @change="provinceChange" v-model="formInline.province_name" filterable  placeholder="请选择省份">
            <el-option
              v-for="item in province_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="cityChange" v-model="formInline.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
            <el-option
              v-for="item in city_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="regionChange" v-model="formInline.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
            <el-option
              v-for="item in region_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button style="background-color: #5daf34;color: #ffffff;" size="small"  @click="batchInput" v-auth="'/plus/data/import/vision_upload'">导入</el-button></el-form-item>

      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column width="70 !important" prop="vision_id" label="ID"></el-table-column>
            <el-table-column width="70 !important" prop="province_name" label="省"></el-table-column>
            <el-table-column width="70 !important" prop="city_name" label="市"></el-table-column>
            <el-table-column prop="region_name" label="区"></el-table-column>
            <el-table-column prop="school_name" label="学校"></el-table-column>
            <el-table-column prop="grade_name" label="年级"></el-table-column>
            <el-table-column prop="class_name" label="班级"></el-table-column>
            <el-table-column prop="student_name" label="学生姓名"></el-table-column>
            <el-table-column prop="birthday" label="出生日期"></el-table-column>
            <el-table-column prop="gender" label="性别">
              <template slot-scope="scope">
                {{ scope.row.gender | convertSex }}
              </template>
            </el-table-column>
            <el-table-column prop="id_card" label="身份证号"></el-table-column>
            <el-table-column prop="student_number" label="学籍号"></el-table-column>
            <el-table-column prop="parents_name" label="家长姓名"></el-table-column>
            <el-table-column prop="mobile" label="家长手机号"></el-table-column>
            <el-table-column prop="residential_address" label="居住地址"></el-table-column>
            <el-table-column width="70 !important" prop="left_eyesight" label="左眼视力（裸眼）" ></el-table-column>
            <el-table-column width="70 !important" prop="right_eyesight" label="右眼视力（裸眼）" ></el-table-column>
            <el-table-column width="70 !important" prop="double_eyesight" label="双眼视力（裸眼）"></el-table-column>
            <el-table-column prop="test_time" label="检测日期"></el-table-column>
            <el-table-column prop="create_time" label="上传时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-auth="'/plus/vision/vision/edit'" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button v-auth="'/plus/vision/vision/delete'" @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  </div>
</template>
<script>
  import VisionApi from '@/api/vision.js';
  import Upload from '@/components/file/import';
  export default {
    components: {
      Upload
    },

    data() {
      return {
        formInline: {

        },

        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
        /* 城市锁 */
        lock_city:true,
        /* 区域锁 */
        lock_region:true,
        province_options:{},
        city_options:{},
        region_options:{},
        /*是否显示*/
        dialogVisible: false,
        open_upload:false,
        // 导入类型
        import_type:'vision',

      };
    },
    created() {
      /*获取列表*/
      this.getData();

      this.getAddressList();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        VisionApi.getVisionList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
      /* 省市区 */
      getAddressList(){
        let self = this;
        VisionApi.provinceList('',true)
          .then(data => {
            console.log(data)
            self.province_options = data.data.list;
          })
          .catch(error => {

          })
      },
      /* 省 */
      provinceChange(selVal){
        let self = this
        /* 判断锁 */
        if (!self.lock_city){
          self.formInline.city_name = ''
          self.formInline.city_id = ''
          self.lock_region = true
          self.formInline.region_name = ''
          self.formInline.region_id = ''
        }
        self.lock_city = false
        self.formInline. province_name = selVal.name
        self.formInline. province_id = selVal.id
        self.cityList(selVal.id)
      },
      /* 市列表 */
      cityList(id){
        let self = this;
        let Params = {}
        Params.province_id = id
        VisionApi.city_list(Params,true)
          .then(data => {
            self.city_options = data.data.list
          })
          .catch(error =>{

          });
      },
      cityChange(selVal){
        let self = this
        if (!self.lock_region){
          self.formInline.region_name = ''
          self.formInline.region_id = ''
        }
        self.lock_region = false
        self.formInline.city_name = selVal.name
        self.formInline.city_id = selVal.id
        self.regionList(selVal.id);
      },
      /* 区域 */
      regionList(id){
        let self = this;
        let Params = {}
        Params.region_id = id
        VisionApi.region_list(Params,true)
          .then(data => {
            console.log(data)
            self.region_options = data.data.list
          })
          .catch(error =>{

          });
      },
      regionChange(selVal){
        let self = this
        self.formInline.region_name = selVal.name
        self.formInline.region_id = selVal.id
        /* 层级太深，需要手动刷新渲染 */
        self.$forceUpdate();
        console.log(self.formInline.region_name)
        console.log(self.region_options)
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getData();
      },


      // 数据导入
      batchInput:function(row){
        this.open_upload = true
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'upload') {
          this.open_upload = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },

      /*修改视力数据*/
      editClick(e) {
        let self = this;
        this.$router.push({
          path: '/plus/vision/vision/edit',
          query: {
            vision_id: e.vision_id
          }
        })
      },

      /*删除视力数据*/
      deleteClick(e) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          VisionApi.deleteVision({
            vision_id: e.vision_id
          }, true).then(data => {
            self.loading = false;
            self.$message({
              message: data.msg,
              type: 'success'
            });
            self.getData();

          })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {
          self.loading = false;
        });
      },

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/vision/vision/index.vue